import { connect } from 'react-redux';
import { GroupCall, GroupCallProps } from '../components/GroupCall';
import { join, setMicrophone, endCall } from '../core/sideEffects';
import { setLocalVideoStream } from '../core/actions/streams';
import { setVideoDeviceInfo, setAudioDeviceInfo } from '../core/actions/devices';
import {
  AudioDeviceInfo,
  VideoDeviceInfo,
  LocalVideoStream,
  TeamsMeetingLinkLocator,
  GroupCallLocator
} from '@azure/communication-calling';
import { State } from '../core/reducers';
import { dialogBoxVisible } from 'core/actions/calls';
import { sendMessage } from '../core/chatSideEffects';
import { setAddIfo } from '../core/actions/ThreadAction';

const mapStateToProps = (state: State, props: GroupCallProps) => ({
  messages: state.chat.messages,
  displayName: state.calls.callAgent?.displayName,
  serverCallId: state.calls.serverCallId,
  userId: state.sdk.userId,
  callClient: state.sdk.callClient,
  callAgent: state.calls.callAgent,
  deviceManager: state.devices.deviceManager,
  screenWidth: props.screenWidth,
  groupId: props.groupId,
  call: state.calls.call,
  shareScreen: state.controls.shareScreen,
  mic: state.controls.mic,
  callEndReason: state.calls.callEndReason,
  join: async (locator: GroupCallLocator | TeamsMeetingLinkLocator) => {
    state.calls.callAgent &&
      (await join(state.calls.callAgent, locator, {
        videoOptions: {
          localVideoStreams: state.streams.localVideoStream ? [state.streams.localVideoStream] : undefined
        },
        audioOptions: { muted: !state.controls.mic }
      }));
  },
  remoteParticipants: state.calls.remoteParticipants,
  callState: state.calls.callState,
  localVideo: state.controls.localVideo,
  localVideoStream: state.streams.localVideoStream,
  screenShareStreams: state.streams.screenShareStreams,
  videoDeviceInfo: state.devices.videoDeviceInfo,
  audioDeviceInfo: state.devices.audioDeviceInfo,
  videoDeviceList: state.devices.videoDeviceList,
  audioDeviceList: state.devices.audioDeviceList,
  cameraPermission: state.devices.cameraPermission,
  microphonePermission: state.devices.microphonePermission,
  recordingStatus: state.calls.recordingStatus,
  recordingError: state.calls.recordingError,
  isDialogBoxVisiblile: state.calls.dialogBoxVisible,
  isBeingRecorded: state.calls.isBeingRecorded,
  isBeingTranscribed: state.calls.isBeingTranscribed,
  darkColor: props.darkColor,
  lightColor: props.lightColor,
  endCall: () => {
    state.calls.call && endCall(state.calls.call, { forEveryone: false });
  },
});

const mapDispatchToProps = (dispatch: any) => ({
  mute: () => dispatch(setMicrophone(false)),
  setAudioDeviceInfo: (deviceInfo: AudioDeviceInfo) => {
    dispatch(setAudioDeviceInfo(deviceInfo));
  },
  setVideoDeviceInfo: (deviceInfo: VideoDeviceInfo) => {
    dispatch(setVideoDeviceInfo(deviceInfo));
  },
  dialogBoxVisiblilty: (dialogBoxVisibilty: boolean) => dispatch(dialogBoxVisible(dialogBoxVisibilty)),
  setLocalVideoStream: (localVideoStream: LocalVideoStream) => dispatch(setLocalVideoStream(localVideoStream)),
  onSendMessage: (messageContent: string) => dispatch(sendMessage(messageContent)),
  setAddInfo: (info: object) => {
    dispatch(setAddIfo(info));
  },
});

const connector: any = connect(mapStateToProps, mapDispatchToProps);
export default connector(GroupCall);
